module.exports = __webpack_public_path__ + "static/media/hired.09f0050b.svg";